import React, {FC, useState, useRef, useEffect, ReactElement} from 'react';
import './content.scss';

interface Props {
    children: any;
}
export const ContentPanel: FC<Props> = ({children}) => {

    return (
        <div className='content content-panel'>
            {children}
        </div>
    )
}